import { DashboardUpsellCopy } from '@chegg-wt/core/types/features'
import { CITATION_LIST_NAME_LOWER_PLURAL } from '@chegg-wt/core/constants/citations'
import { Config } from '@chegg-wt/core/config'

export const upsellCopy: DashboardUpsellCopy = {
  plagiarism: {
    UPSELL_HEADING: 'Writing help from start to finish',
    CTA_COPY: 'Start a free trial*',
    FEATURE_LIST: [
      'Unlimited plagiarism & grammar checks',
      'Summarized feedback from writing experts',
      '7,000+ styles including APA & Chicago',
    ],
    IMAGE_ALT_TEXT: 'plagiarism detected paper',
  },
  expertCheck: {
    UPSELL_HEADING: 'Get an Expert Check for your paper',
    CTA_COPY: 'Try Expert Check',
    FEATURE_LIST: [
      'Custom summary feedback on your main idea, writing style, and more',
      'Receive comments back within 24 hours',
      `Submit up to 30 papers a month, up to ${Config.paperCheckWordCountLimit} words each`,
    ],
  },
  citation: {
    UPSELL_HEADING: 'Create a new citation',
    CTA_COPY: 'Unlock citations',
    FEATURE_LIST: [
      'Cite in all styles - APA, Chicago, and 7000 more',
      'Save and update your citations online',
      'Export your formatted citations to add to your assignments',
    ],
  },
  citationsCTA: {
    UPSELL_HEADING: 'Start creating citations',
    UPSELL_SUBHEADING: `Create and manage unlimited ${CITATION_LIST_NAME_LOWER_PLURAL}`,
    CTA_COPY: 'Start free trial*',
    FEATURE_LIST: [
      'Cite in all styles - APA, Chicago, and 7000 more',
      'Save and update your citations online',
      'Export your formatted citations to add to your assignments',
    ],
  },
}
